import React, { Component } from 'react';
import Artboard from "../../assets/ourides/artboard.png";
import ModalVideo from 'react-modal-video';

export default class Pitch extends Component {
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    
    openModal () {
        this.setState({isOpen: true})
    }

    render() {
        return (
            <div className="pitch__main">
                <div className="pitch__container">
                    <img src={Artboard} className="pitch__bg" />
                    <div className="pitch__wrapper">
                        <h4 className="pitch__title rides-title"> Pourquoi devrais-je louer mes affaires? </h4>
                        <p className="pitch__text"> La plupart des gens n'utilisent leur bateau, kayak, VR, VTT, etc. que quelques fois par année. Le restant du temps, ils accumulent la poussière dans leur garage! Notre mission est de permettre aux propriétaires de rentabiliser leurs balades en les louant aux vacanciers désireux d'en profiter pour leurs expériences récréatives qui paieront à l'heure ou à la journée. </p>
                        <div className="pitch__video">
                            <ModalVideo 
                                channel='youtube'
                                isOpen={this.state.isOpen} 
                                videoId="dmRCzdWJ7Go"
                                onClose={() => this.setState({isOpen: false})}
                            />
                            <a onClick={this.openModal} className="pitch__cta"> Voir la vidéo </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}